/* eslint-disable */
// prettier-ignore
export default {}
/* eslint-enable */
